import * as types from '../const/action.types';

export function employee(state = {}, action) {
    switch (action.type) {
        case types.LOAD_EMPLOYEE_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function employees(state = [], action) {
    switch (action.type) {
        case types.EMPLOYEES_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function employeesHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.EMPLOYEES_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function employeesIsLoading(state = false, action) {
    switch (action.type) {
        case types.EMPLOYEES_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/employee.reducer.js